<template>
  <table class="wd-100p table-bordered table-striped">
    <thead>
      <tr>
        <th>Д/д</th>
        <th>Огноо</th>
        <th>Хэрэглэгч</th>
        <th>Ном</th>
        <th>Төлөв</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(t, i) in tasks" :key="i">
        <td class="text-right tx-color-03">{{ i + 1 }}</td>
        <td>{{ t.createdDate | moment("YYYY.MM.DD HH:mm") }}</td>
        <td>
          <span v-if="t.secondUser != null">{{ t.secondUser.fullName }}</span>
        </td>
        <td>
          <span v-if="t.organizationTask != null">{{
            t.organizationTask.task
          }}</span>
        </td>
        <td class="text-right pd-y-5 tx-12">
          <div v-if="t.i1 == 2">
            <span class="badge badge-success">Буцаан авсан</span>
            <div>{{ t.d2 | moment("YYYY.MM.DD HH:mm, dddd") }}</div>
          </div>
          <span v-else-if="t.i1 == -1" class="badge badge-secondary"
            >цуцалсан</span
          >
          <div v-if="t.i1 == 1">
            <span class="badge badge-warning">Баталгаажсан</span>
            <div class="mg-b-5">
              {{ t.d1 | moment("YYYY.MM.DD HH:mm, dddd") }}
            </div>
            <a
              @click="$emit('on-giveback', t)"
              class="text-uppercase link-01 bd pd-y-3 pd-x-5 rounded bg-white"
              role="button"
            >
              <feather type="check"></feather>
              Хүлээж авах
            </a>
          </div>
          <div v-else-if="t.i1 == 0">
            <div>
              <div class="badge badge-success">shine zahialga</div>
            </div>
            <div class="btn-group mg-t-5">
              <button
                @click="$emit('on-decline', t)"
                class="btn btn-xs btn-danger"
              >
                Цуцлах
              </button>
              <button
                @click="$emit('on-accept', t)"
                class="btn btn-xs btn-success"
              >
                Батлах
              </button>
            </div>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  props: {
    tasks: {
      type: Array,
      default: () => []
    }
  }
};
</script>

<style></style>
